export const addCssUrlToHead = async (cssConf, id) => {
  return new Promise((resolve, reject) => {
    if (document.getElementById(id)) {
      return resolve()
    }
    const link = document.createElement('link')
    link.id = id
    link.href = cssConf.url
    link.type = 'text/css'
    link.rel = 'stylesheet'
    link.onload = resolve
    link.onerror = reject

    // it seems we cannot check the integrity in some browsers
    // if (cssConf.integrity) {
    //   console.log(`has integrity check:`, cssConf)
    //   link.integrity = cssConf.integrity
    //   link.crossorigin = ''
    // }

    document.head.appendChild(link)
  })
}

export const addCssToHead = async (css, id) => {
  return new Promise((resolve, reject) => {
    if (document.getElementById(id)) {
      return resolve()
    }
    const script = document.createElement('style')
    script.id = id
    script.textContent = css
    script.onload = resolve
    script.onerror = reject

    document.head.appendChild(script)
  })
}

export const addScriptToHead = async (scriptConf, id) => {
  return new Promise((resolve, reject) => {
    if (document.getElementById(id)) {
      return resolve()
    }
    const script = document.createElement('script')
    script.id = id
    script.src = scriptConf.url
    script.type = 'text/javascript'
    script.charset = 'utf-8'
    script.onload = resolve
    script.onerror = reject

    // it seems we cannot check the integrity in some browsers
    // if (scriptConf.integrity) {
    //   script.integrity = integrity
    //   script.crossorigin = ''
    // }

    document.head.appendChild(script)
  })
}



// WEBPACK FOOTER //
// ./src/utils/DocumentHelper.js